import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_IS_EXCESS_REDUCTION2, propTypes } from '../../util/types';
import Explanation from './Explaination';

import css from './BookingBreakdownNew.css';

const LineItemNewExcessReduction2AddOnMaybe = props => {
  const { transaction, isCustomer, intl } = props;
  if(!transaction || transaction === null) return null;
  let excessReduction2LineItem = null;

  if (isCustomer) {
    excessReduction2LineItem = transaction.attributes.lineItems.find(
      item => item.code === LINE_ITEM_IS_EXCESS_REDUCTION2 && !item.reversal
    );
  }

  if (!excessReduction2LineItem || excessReduction2LineItem.length === 0) {
    return null;
  }

  const commission = excessReduction2LineItem.lineTotal;

  const formattedCommission = commission ? formatMoney(intl, commission, 1) : null;

  return formattedCommission ? (
    <div className={css.addOnLineItem}>
      <div className={css.totalLabel}>
        <FormattedMessage id="BookingBreakdown.excessReduction2" />
        <Explanation text="Reduced liability with savings up to $6420" />
      </div>
      <div className={css.itemValue}>{formattedCommission}</div>
    </div>
  ) : null;
};

LineItemNewExcessReduction2AddOnMaybe.propTypes = {
  transaction: propTypes.transaction.isRequired,
  isCustomer: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemNewExcessReduction2AddOnMaybe;
